import { SidenavUtils } from '@/common/utils/SideNavUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';

const gpSideNav = {
  id: 'gp',
  shortName: 'GP',
  displayName: 'Government Pricing',
  role: 'GP_VIEW',
  icon: fas.faLandmarkAlt,
  precedence: 2,
  route: '/gp',
  children: [
    // Organization Menu
    SidenavUtils.orgMenu('gp'),

    // Calculations Section
    {
      id: 'gpCalcMenu',
      displayName: 'Calculations',
      role: 'GP_CALC_VIEW',
      icon: fas.faCalculator,
      precedence: 10,
      children: [
        {
          id: 'gpPriceCalc',
          displayName: 'Prices',
          role: 'GP_CALC_VIEW',
          icon: fas.faUsdCircle,
          route: '/gp/calc/price',
          precedence: 11,
        },
        {
          id: 'gpReallocCalc',
          displayName: 'Reallocations',
          role: 'GP_CALC_VIEW',
          icon: fas.faRetweet,
          route: '/gp/calc/realloc',
          precedence: 12,
        },
        {
          id: 'gpEstCalc',
          displayName: 'Estimates',
          role: 'GP_CALC_VIEW',
          icon: fas.faTasksAlt,
          route: '/gp/calc/est',
          precedence: 13,
        },
        {
          id: 'gpCalcDashboard',
          displayName: 'Reallocation Dashboard',
          role: 'GP_CALC_VIEW',
          icon: fas.faTachometer,
          route: '/gp/calc-dashboard',
          precedence: 14,
        },
      ],
    },

    // Policies Section
    {
      id: 'gpPolMenu',
      displayName: 'Policies',
      role: 'GP_POL_VIEW',
      icon: fas.faHandsHelping,
      precedence: 20,
      route: 'gp/pol',
    },

    // FSS Monitoring Section
    {
      id: 'gpFssMenu',
      displayName: 'FSS Monitoring',
      role: 'GP_FSS_MONITORING_VIEW',
      icon: fas.faTachometer,
      precedence: 40,
      children: [
        {
          id: 'gpFssTrackingEntity',
          displayName: 'Tracking Entity',
          role: 'GP_FSS_TRACKING_ENTITY_VIEW',
          icon: fas.faUser,
          route: '/gp/fss-tracking-entity',
          precedence: 41,
        },
        {
          id: 'gpFssNotif',
          displayName: 'Notifications',
          role: 'GP_FSS_NOTIF_VIEW',
          icon: fas.faBell,
          route: '/gp/fss-notif',
          precedence: 42,
        },
      ],
    },
    // Common Menus
    ...SidenavUtils.commonMenus('gp'),
  ],
};

export default gpSideNav;
